import { z } from 'zod';

export const TIME_RANGE_VALUES = ['1h', '3h', '6h', '12h', '24h', '3d', '7d'] as const;

export const SUPPORTED_TIME_RANGES = TIME_RANGE_VALUES;

export type SupportedTimeRange = (typeof TIME_RANGE_VALUES)[number];

export const TimeRangeSchema = z.enum(TIME_RANGE_VALUES);
